"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerSelectMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Button = require("../../components/Button/Button.styles");
var _Icon = require("../../components/Icon/Icon.styles");
var _constants = require("../../constants");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
/** @class DatePickerSelectMixin */
/** @method */
var DatePickerSelectMixin = function DatePickerSelectMixin(props) {
  return (0, _styledToken.default)({
    caretSize: 'DatePickerSelect.caretSize',
    iconSize: 'DatePickerSelect.Button.icon.size',
    hoverBackgroundColor: 'DatePickerSelect.Select.backgroundColor.hover',
    boxShadow: 'DatePickerSelect.boxShadow.focus',
    paddingLeft: 'DatePickerSelect.paddingLeft',
    selectFontType: 'DatePickerSelect.Select.fontType',
    selectPadding: 'DatePickerSelect.Select.padding',
    selectPaddingRight: 'DatePickerSelect.Select.paddingRight',
    buttonIconRotation: 'DatePickerSelect.Button.icon.rotate',
    buttonTop: 'DatePickerSelect.Button.rotate',
    buttonRight: 'DatePickerSelect.Button.rotate'
  }, function (_ref) {
    var caretSize = _ref.caretSize,
      iconSize = _ref.iconSize,
      hoverBackgroundColor = _ref.hoverBackgroundColor,
      boxShadow = _ref.boxShadow,
      paddingLeft = _ref.paddingLeft,
      _ref$selectFontType = _ref.selectFontType,
      selectFontType = _ref$selectFontType === void 0 ? _constants.FONT_TYPES.bodyHeading : _ref$selectFontType,
      _ref$selectPadding = _ref.selectPadding,
      selectPadding = _ref$selectPadding === void 0 ? 0 : _ref$selectPadding,
      selectPaddingRight = _ref.selectPaddingRight,
      _ref$buttonIconRotati = _ref.buttonIconRotation,
      buttonIconRotation = _ref$buttonIconRotati === void 0 ? '90deg' : _ref$buttonIconRotati,
      _ref$buttonTop = _ref.buttonTop,
      buttonTop = _ref$buttonTop === void 0 ? 0 : _ref$buttonTop,
      _ref$buttonRight = _ref.buttonRight,
      buttonRight = _ref$buttonRight === void 0 ? 0 : _ref$buttonRight;
    return (0, _styledComponents.css)(["position:relative;display:inline-block;padding-left:", ";select{appearance:none;border:none;background:none;box-shadow:none;cursor:pointer;padding:", ";padding-right:", ";", " height:", "px;line-height:", "px;&:hover{& + button{background-color:", ";}}&:focus{outline:0;& + ", "{box-shadow:", ";}}&::-ms-expand{display:none;}}", "", "{position:absolute;top:", "px;right:", "px;pointer-events:none;width:", "px;height:", "px;", "{height:", "px;width:", "px;transform:rotate(", ");}}"], paddingLeft ? paddingLeft + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props), selectPadding, selectPaddingRight ? selectPaddingRight + "px" : (0, _spaceMixin.spaceMixin)('lg')(props), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: selectFontType
    }, props)), caretSize, caretSize, hoverBackgroundColor, _Button.StyledButton, boxShadow, _Button.StyledButton, _Button.StyledButton, buttonTop, buttonRight, caretSize, caretSize, _Icon.StyledIcon, iconSize, iconSize, buttonIconRotation);
  })(props);
};
exports.DatePickerSelectMixin = DatePickerSelectMixin;